import _ from 'lodash';
import { TPortableText } from '@typings/TPortableText';
import { isPortableTextBlock } from './isPortableTextBlock';

export const isPortableText = <O extends any>(input: (O | TPortableText[number])[]): input is TPortableText => {
  return input.every(o => {
    if (
      isPortableTextBlock(o)
      || (_.get(o, '_type') === 'inlineImage' && !_.isNil(_.get(o, 'src')))
    ) {
      return true;
    }
    return false;
  });
}